import type { BlobLike } from "@pdfking/compatibility"
import type { Degree, Pixel, Rectangle } from "@pdfking/math"
import type { Sequence } from "@pdfking/tfunc"
import type { PDFReaderOptions } from "./PDFReaderOptions"

export type ColorChannel = "cyan" | "magenta" | "yellow" | "black"
/** CMYK halftone screen angles in degrees */
export type ChannelInclination = {
  /** Cyan screen angle
   * @default 165
   */
  cyan: Degree
  /** Magenta screen angle
   * @default 100
   */
  magenta: Degree
  /** Yellow screen angle
   * @default 0
   */
  yellow: Degree
  /** Black screen angle
   * @default 45
   */
  black: Degree
}

export type PDFSeparationResult = {
  page: number
  channels: { channel: ColorChannel; blob: BlobLike }[]
} & Rectangle<Pixel>

export type PDFSeparationFunction = (
  input: PDFReaderOptions,
  options: {
    angle: ChannelInclination
    dpi: Pixel
    lpi: Pixel
  },
  rangeFn?: (page_count: number) => Sequence<number>
) => AsyncGenerator<PDFSeparationResult>
